{
  "top-salons-page": {
    "text": {
      "title": "Top Salons",
      "hint": "Discover the most popular beauty salons in your favorite cities.",
      "country-label": "Country",
      "country": {
        "DE": "Germany",
        "CH": "Switzerland",
        "NL": "Netherlands"
      }
    },
    "meta": {
      "title": "Top Salons | Beauty Booking",
      "description": "Discover the most popular beauty salons in Germany, Switzerland and the Netherlands."
    }
  }
}
